import { PaginatorLaboratoryDatasource } from '@/shared/resources/datasources/paginator/paginator-laboratory-datasource'
import {
    CommonFilterModel,
    CommonPaginatorResourceService,
    CommonParams
} from '@/api/resources/common/shared/models/common.models'
import { IResponseAgGrid } from '@/shared/models/ag-grid.model'

export class PaginatorLaboratoryDynamicDatasource<T> extends PaginatorLaboratoryDatasource<T> {
    protected readonly _url: string

    constructor(service: CommonPaginatorResourceService<T>, laboratoryId: number, url: string) {
        super(service, laboratoryId)
        this._url = url
    }

    protected fetchData(filterModel: CommonFilterModel, params: CommonParams): Promise<IResponseAgGrid<T>> {
        if (!this.service) {
            throw new Error('undefined service')
        }
        return this.service.paginator(filterModel, params, this.laboratoryId, this._url)
    }
}
